import { isBrowser } from ".";

function isStorageValid(storage: Storage): boolean {
  return !!storage && typeof storage.key !== "undefined";
}

export function getValueFrom(
  storage: Storage,
  key: string,
): any | null | undefined {
  if (!isStorageValid(storage)) {
    return undefined;
  }

  const rawData = storage.getItem(key);

  if (!rawData) {
    return null;
  }

  return JSON.parse(rawData);
}

export function setValueTo(storage: Storage, key: string, data: any): void {
  if (!isStorageValid(storage)) {
    return;
  }
  return storage.setItem(key, JSON.stringify(data));
}

export const getFromLocal = (key: string): any | null | undefined => {
  if (isBrowser()) {
    const localStorage = window.localStorage;
    return getValueFrom(localStorage, key);
  }
};

export const setToLocal = (key: string, value: any): void => {
  if (isBrowser()) {
    const localStorage = window.localStorage;
    return setValueTo(localStorage, key, value);
  }
};
